import { Inject, Injectable } from '@angular/core';
import { CfbFeatureFlagService } from './cfb-feature-flag.service';
import {
  CFB_INTEGRATION_STATE_PORT,
  CfbIntegrationStatePort,
} from './cfb-integration-state.port';
import {
  isIntegrationRegistrationSessionActive,
  setIntegrationRegistrationSessionActive,
} from './cfb-integration-registration.util';

@Injectable({
  providedIn: 'root',
})
export class CfbIntegrationRegistrationService {
  constructor(
    @Inject(CFB_INTEGRATION_STATE_PORT)
    private readonly integrationState: CfbIntegrationStatePort,
    private readonly cfbFeatureFlagService: CfbFeatureFlagService,
  ) {}

  isActive(): boolean {
    return (
      isIntegrationRegistrationSessionActive() &&
      this.cfbFeatureFlagService.isIntegrationOn()
    );
  }

  activate(): void {
    if (!this.cfbFeatureFlagService.isIntegrationOn()) {
      return;
    }

    setIntegrationRegistrationSessionActive(true);
    this.syncShellState();
  }

  deactivate(): void {
    setIntegrationRegistrationSessionActive(false);
    this.integrationState.setIntegrationOn(false);
  }

  syncShellState(): void {
    if (
      !isIntegrationRegistrationSessionActive() &&
      !this.cfbFeatureFlagService.isIntegrationOn()
    ) {
      this.integrationState.setIntegrationOn(false);
      return;
    }

    this.integrationState.setIntegrationOn(
      this.cfbFeatureFlagService.isIntegrationOn(),
    );
  }
}
